import React from "react";

export const UnauthorizedComponent = (): JSX.Element => (<div>{"401!"}</div>);
